"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ConfigSelectors = require("pricing-pages-unified-ui/selectors/ConfigSelectors");

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

// Code splits between an authed component and a public component
// Takes in a loader so we can do the code splitting inside this function
var CodeSplitEnvWrapper =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CodeSplitEnvWrapper, _React$Component);

  function CodeSplitEnvWrapper(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CodeSplitEnvWrapper);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CodeSplitEnvWrapper).call(this, props));
    _this.authedComponent = null;
    _this.publicComponent = null;

    if (props.authedComponentLoader) {
      _this.authedComponent = (0, _Loadable.default)({
        loader: props.authedComponentLoader,
        LoadingComponent: function LoadingComponent() {
          return null;
        },
        ErrorComponent: function ErrorComponent() {
          throw new Error('EnvironmentWrapper authed component Loadable error');
        }
      });
    }

    if (props.publicComponentLoader) {
      _this.publicComponent = (0, _Loadable.default)({
        loader: props.publicComponentLoader,
        LoadingComponent: function LoadingComponent() {
          return null;
        },
        ErrorComponent: function ErrorComponent() {
          throw new Error('EnvironmentWrapper public component Loadable error');
        }
      });
    }

    return _this;
  }

  (0, _createClass2.default)(CodeSplitEnvWrapper, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isAppAuth = _this$props.isAppAuth,
          authedComponentProps = _this$props.authedComponentProps,
          publicComponentProps = _this$props.publicComponentProps;

      if (isAppAuth && this.authedComponent) {
        return _react.default.createElement(this.authedComponent, authedComponentProps);
      } else if (!isAppAuth && this.publicComponent) {
        return _react.default.createElement(this.publicComponent, publicComponentProps);
      }

      return null;
    }
  }]);
  return CodeSplitEnvWrapper;
}(_react.default.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isAppAuth: (0, _ConfigSelectors.isAppAuthSelector)(state)
  };
};

CodeSplitEnvWrapper.propTypes = {
  // https://product.hubteam.com/docs/crm-handbook/practices/code-splitting.html#creating-a-chunk-with-dynamic-import
  // () => import(/* webpackChunkName: "authed-chunk" */  'path/to/component')
  authedComponentLoader: _propTypes.default.func,
  // () => import(/* webpackChunkName: "public-chunk" */  'path/to/component')
  publicComponentLoader: _propTypes.default.func,
  authedComponentProps: _propTypes.default.object.isRequired,
  publicComponentProps: _propTypes.default.object.isRequired,
  isAppAuth: _propTypes.default.bool.isRequired
};
CodeSplitEnvWrapper.defaultProps = {
  authedComponentLoader: null,
  publicComponentLoader: null,
  authedComponentProps: {},
  publicComponentProps: {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(CodeSplitEnvWrapper);

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/CodeSplitEnvWrapper.js
// module id = 83
// module chunks = 5 6